import { TableCell, TableRow } from '@mui/material'
import moment from 'moment'
import React from 'react'
import Link from '../common/util/input/Link'

export const AssetTransactionItem = ({ transaction }) => {
    const txId = transaction['txid']
    const name = transaction['name'] ? transaction['name'] : 'transfer'

    const sender = transaction['sender_name']
        ? transaction['sender_name']
        : transaction['data'] && transaction['data']['authorized_minter']
        ? transaction['data']['authorized_minter']
        : ''
    const receiver = transaction['recipient_name']
        ? transaction['recipient_name']
        : transaction['data'] && transaction['data']['new_asset_owner']
        ? transaction['data']['new_asset_owner']
        : ''

    const timestamp = parseInt(transaction['created_at_time'])
    const utc = moment.utc(timestamp).toDate()
    const date = moment(utc).local().format('YYYY-MM-DD HH:mm:ss')

    return (
        <TableRow>
            <TableCell>{date}</TableCell>
            <TableCell>{name}</TableCell>
            <TableCell>
                <Link
                    href={'https://waxblock.io/transaction/' + txId}
                    external={true}
                    className={'text-primary hover:underline'}
                >
                    {txId ? txId.substring(0, 8) + '...' : ''}
                </Link>
            </TableCell>
            <TableCell>
                <Link
                    href={'/user/' + sender}
                    className={'text-primary hover:underline'}
                >
                    {sender}
                </Link>
            </TableCell>
            <TableCell>{'>'}</TableCell>
            <TableCell>
                <Link
                    href={'/user/' + receiver}
                    className={'text-primary hover:underline'}
                >
                    {receiver}
                </Link>
            </TableCell>
        </TableRow>
    )
}
